import {Component, OnDestroy} from '@angular/core';
import {DialogRef} from "@angular/cdk/dialog";
import {MqttGetModuleConfigDto} from "../../interfaces/mqtt/mqtt-get-module-config.dto";
import {DeviceDataService} from "../../services/device-data.service";
import {Subscription} from "rxjs";
import {ShareService} from "../../services/share.service";

@Component({
  selector: 'app-module-configuration-modal',
  templateUrl: './module-configuration-modal.component.html',
  styleUrls: ['./module-configuration-modal.component.scss']
})
export class ModuleConfigurationModalComponent implements OnDestroy {
  public moduleConfig: MqttGetModuleConfigDto;
  public isLoading = false;

  private subscription: Subscription;

  constructor(
    private dialogRef: DialogRef<null>,
    private deviceDataService: DeviceDataService,
    private shareService: ShareService
  ) {
    this.subscription = this.deviceDataService.moduleConfig$.subscribe((moduleConfig => {
      if (moduleConfig == null) return;
      this.moduleConfig = moduleConfig.moduleConfig;
      this.isLoading = moduleConfig.isLoading;
    }));
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  public async loadModuleConfig() {
    await this.deviceDataService.loadModuleConfig(this.shareService.getGatewayId());
  }

  closeModal() {
    this.dialogRef.close();
  }

}
